import { useCallback, useMemo } from 'react';
import { createId } from '@paralleldrive/cuid2';
import type { Chat } from '@trinity/chat';
import { RegenerateMessageContext } from './context';
import { useRegenerateQueryMutation } from './hooks/useRegenerateQueryMutation';

type Props = {
  children: React.ReactNode;
};

export const RegenerateMessageContainer = (props: Props) => {
  const { isPending, mutateAsync } = useRegenerateQueryMutation();

  const handleRegenerate = useCallback((query: Chat.Query) => {
    const identifier = createId();
    return mutateAsync({ identifier, sourceQuery: query });
  }, [mutateAsync]);

  const ctx = useMemo(() => ({
    canRegenerate: true,
    isRegenerating: isPending,
    onRegenerate: handleRegenerate,
  }), [
    isPending,
    handleRegenerate,
  ]);

  return (
    <RegenerateMessageContext.Provider value={ctx}>
      {props.children}
    </RegenerateMessageContext.Provider>
  );
};